/**
 * headingLevelStyle.js
 * ────────────────────
 * Shared helper for HeadingBlock / HeadingBlockAdmin.
 *
 * Builds the inline style for a heading element so that each CSS property
 * resolves from the per-level site variable (--site-h2-size, etc.), then
 * the global heading variable where one exists, and finally `inherit` so
 * the wrapper's typography trait cascades into the heading.
 */

/**
 * @param {string} tag  One of h1..h6
 * @returns {Object} Vue inline style object
 */
export function buildHeadingLevelStyle(tag) {
	var lvl = '--site-' + tag + '-';
	return {
		color:          'var(' + lvl + 'color, var(--site-heading-color, inherit))',
		fontFamily:     'var(' + lvl + 'font, var(--site-heading-font, inherit))',
		fontSize:       'var(' + lvl + 'size, inherit)',
		fontWeight:     'var(' + lvl + 'weight, inherit)',
		fontStyle:      'var(' + lvl + 'style, inherit)',
		lineHeight:     'var(' + lvl + 'line-height, inherit)',
		letterSpacing:  'var(' + lvl + 'letter-spacing, inherit)',
		textTransform:  'var(' + lvl + 'transform, inherit)',
		textDecoration: 'var(' + lvl + 'decoration, inherit)'
	};
}
